import { Role, SERVICE_ENGINEER_POSTFIX } from 'domain/shared/core/constants';
import { ROLES_ALLOWED_TO_REMOVE, useCompanyRolesService } from '../shared/companyRolesService';
import { DataGridLayout, List, RelationListLayout } from 'framework/list';
import { useIsMyProfile } from 'domain/shared/employee';
import AddCompanyRoleToEmployeeButton from './buttons/AddCompanyRoleToEmployeeButton';
import { TextField } from 'framework/ui/field';
import RemoveEmployeeCompanyRoleButton from './buttons/RemoveEmployeeCompanyRoleButton';
import { Box } from '@mui/material';
import CareerSectionTitle from 'domain/people/employee/CareerCapabilities/shared/CareerSectionTitle';

const RelatedCompanyRolesList = () => {
  const isMyProfile = useIsMyProfile();
  const { searchRolesByAlias } = useCompanyRolesService();

  const isRemoveRoleButtonVisible = (rowData: any) => {
    const role: Role = rowData.name;
    return (ROLES_ALLOWED_TO_REMOVE.has(role) || role.endsWith(SERVICE_ENGINEER_POSTFIX)) && !isMyProfile;
  };

  return (
    <List getDataMethod={searchRolesByAlias}>
      <Box position="relative">
        <CareerSectionTitle title="Company roles">
          <AddCompanyRoleToEmployeeButton />
        </CareerSectionTitle>

        <RelationListLayout sxHeaderContainer={{ mb: '0 !important' }}>
          <DataGridLayout
            isSmallTable
            sxTableWrapper={{ '& .MuiAlert-standard': { marginTop: 0 } }}
            showTotal={false}
            buttons={[<RemoveEmployeeCompanyRoleButton isVisible={isRemoveRoleButtonVisible} />]}
          >
            <TextField label="Role name" source="name" />
          </DataGridLayout>
        </RelationListLayout>
      </Box>
    </List>
  );
};

export default RelatedCompanyRolesList;
